module.exports = __webpack_public_path__ + "assets/8cf4e7a75cd3771127513006cae8a277.png";